import LandingPageWrapper from "../LandingPageWrapper";
import styles from "./CardBanner.module.css";
import {Column, Container, Row} from "../grid";
import React, {ReactNode} from "react";

type Props = {
    children: ReactNode;
    cardImage: ReactNode;
    logoClassName?: string;
    renderBlueGradient?: boolean;
    renderInterestRates?: boolean;
    renderOnlyCard?: boolean;
};

export default function CardBanner(props: Props) {
    return (
        <LandingPageWrapper
            logoClassName={props.logoClassName}
            renderInterestRates={props.renderInterestRates}
            onlyRenderCardBanner={props.renderOnlyCard}
            renderBlueGradient={props.renderBlueGradient}
        >
            <Container>
                <Row className={styles.row}>
                    <Column large={6} medium={4} className={styles.children}>
                        {props.children}
                    </Column>
                    <Column large={6} medium={4} className={styles.image}>
                        <div className={styles.cardsWrapper}>{props.cardImage}</div>
                    </Column>
                </Row>
            </Container>
        </LandingPageWrapper>
    );
}

CardBanner.defaultProps = {
    renderBlueGradient: true,
    renderInterestRates: false,
    renderOnlyCard: true,
};
